module.exports = __webpack_public_path__ + "static/media/hp-login-banner-@1x.c2bd4ba2.jpg";